import React, { useState, useEffect } from "react";
import "./styles/styles.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { accessoriesDetail } from "../../../../../../redux/actions/accessoriesDetail";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
const CardAccesories = (props) => {
  const { currencySelect } = props;
  const { name, images, price, code, id, description, type } = props.array;

  const [currencyValue, SetCurrencyValue] = useState(0);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  var data = {
    id: id,
    data: {
      code: code,
      name: name,
      images: images,
      description: description,
      type,
      price: price,
    },
  };

  const imagen = JSON.parse(images[0]).url;
  return (
    <Link to={`/product/${data.id}`}>
      <div className="card-accessories" onClick={() => window.scrollTo(0, 0)}>
        <div
          className="imagenAccessories customizableImage"
          style={{
            backgroundImage: `url(${imagen})`,
          }}
        >
          <div className="HeaderAccessories">
            <p className="nameAccesories">
              {code} {name}
            </p>
            <p className="priceAccesories">
              {!currencySelect || currencySelect.loading
                ? "Cargando..."
                : currencyValue === 0
                ? formatCurrency(Math.ceil(price))
                : formatterUSD.format(
                    Math.ceil(price / currencyValue.data.value) - 0.01
                  )}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

const mapStateToProps = (state) => {
  return {
    state,
    currencySelect: state.currencySelect,
  };
};

export default connect(mapStateToProps, {
  accessoriesDetail,
})(CardAccesories);
